import { INTELLIGENT_PHOTO_CAPTURE_RESET_TOAST, INTELLIGENT_PHOTO_CAPTURE_SHOW_TOAST } from '../actions';
export const photoCaptureIntelligentToastReducer = (state, action) => {
    switch (action.type) {
        case INTELLIGENT_PHOTO_CAPTURE_SHOW_TOAST: {
            const payload = action.payload;
            return Object.assign(Object.assign({}, state), { toastNotification: {
                    operationType: payload.operationType,
                    toastType: payload.toastType,
                    customMessage: payload.customMessage
                } });
        }
        case INTELLIGENT_PHOTO_CAPTURE_RESET_TOAST: {
            return Object.assign(Object.assign({}, state), { toastNotification: undefined });
        }
        default:
            return state;
    }
};
//# sourceMappingURL=photoCaptureIntelligentToastReducer.js.map